class BurgerMegaMenu extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.content = this.querySelector('.burger-mega-menu__content');

    if (this.details && this.summary) {
      this.setupEventListeners();
    }
  }

  setupEventListeners() {
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    document.addEventListener('click', this.onBodyClick.bind(this));
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
  }

  onKeyUp(event) {
    if (event.code?.toUpperCase() === 'ESCAPE') {
      this.close();
    }
  }

  onBodyClick(event) {
    if (!this.contains(event.target) && this.details.hasAttribute('open')) {
      this.close();
    }
  }

  onSummaryClick(event) {
    event.preventDefault();

    if (this.details.hasAttribute('open')) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.details.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');
    this.positionContent();

    // Prevent body scroll when menu is open
    document.body.style.overflow = 'hidden';

    // Dispatch custom event
    this.dispatchEvent(
      new CustomEvent('burger-menu-opened', {
        bubbles: true,
        composed: true,
      })
    );
  }

  positionContent() {
    if (!this.content) return;

    const header = document.querySelector('.header-wrapper');
    if (!header) return;

    this.content.style.top = `${Math.floor(header.getBoundingClientRect().bottom)}px`;
  }

  close() {
    this.details.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', 'false');

    // Restore body scroll
    document.body.style.overflow = '';

    // Dispatch custom event
    this.dispatchEvent(
      new CustomEvent('burger-menu-closed', {
        bubbles: true,
        composed: true,
      })
    );
  }
}

customElements.define('burger-mega-menu', BurgerMegaMenu);
